import { DatePipe } from '@angular/common';
import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MultilanguageService } from '@services/support/multilanguage.service';
import { WorkflowService } from '@services/workflow.service';

@Component({
    selector: 'app-table-report',
    templateUrl: './table-report.component.html',
    styleUrls: ['./table-report.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TableReportComponent implements OnInit {

  @Input() tableData?
  @Input() workflowPublishedVersion?
  @Input() workflowTranslations?
  @Input() selectedLang?
  
  workflowTableData

  constructor(
    public workflowService: WorkflowService,
    public multiLanguageService: MultilanguageService) { }

  ngOnInit(): void {
    if (!this.workflowPublishedVersion || !this.tableData) {
      return;
    }

    // Find the layout that contains the table widget
    const tableLayout = this.workflowPublishedVersion.layouts?.find(layout => 
      layout.items?.[0]?.type === 'table'
    );
    
    if (!tableLayout) {
      return;
    }

    this.workflowTableData = tableLayout.items[0].templateOptions.tableData;
    
    if (!this.workflowTableData?.rows) {
      return;
    }
    
    // Process table data to format special field types
    this.processTableData();
  }

  private processTableData(): void {
    for (const row of this.workflowTableData.rows) {
      for (const cellKey of Object.keys(this.tableData)) {
        const cell = row.cells.find(colItem => colItem.key === cellKey);
        
        if (!cell) {
          continue;
        }

        if (cell.type === 'datepicker') {
          this.tableData[cell.key] = this.mapDateData(this.tableData[cell.key]);
        } else if (cell.type === 'multicheckbox') {
          this.tableData[cell.key] = this.mapCheckboxData(cell.key, this.tableData[cellKey]);
        }
      }
    }
  }

  mapDateData(valueItem: any): string {
    if (!valueItem) {
      return '';
    }

    const datePipe: DatePipe = new DatePipe(
      this.multiLanguageService.currentLang.code
    );
    const dateValue = datePipe.transform(valueItem, 'long');
    return dateValue || '';
  }

  mapCheckboxData(checkboxKey: string, selectedOptionKeys: any[]): any[] {
    if (!selectedOptionKeys?.length) {
      return [];
    }

    // Find the checkbox cell in the table structure
    let checkboxItem;
    for (const row of this.workflowTableData.rows) {
      checkboxItem = row.cells.find(colItem => colItem.key === checkboxKey);
      if (checkboxItem) {
        break;
      }
    }

    if (!checkboxItem?.templateOptions?.options) {
      return [];
    }

    // Map selected keys to their values
    const mappedValues = [];
    for (const selectedKey of selectedOptionKeys) {
      const option = checkboxItem.templateOptions.options.find(
        item => item.value === selectedKey
      );
      if (option) {
        mappedValues.push(option.value);
      }
    }

    return mappedValues;
  }

  mapRadioData(radioKey, selectedOptionKey) {
    let radioItem;

    for (const col of this.tableData.rows) {
      radioItem = col.cells.find(colItem => colItem.key == radioKey)
      if (!!radioItem) {
        break;
      }
    }
    let keyItem = radioItem.templateOptions.options.filter(res => selectedOptionKey&& (res.value == selectedOptionKey))

    if(keyItem) {
                  
      let x = radioItem.templateOptions.options.find(item => item.value == selectedOptionKey)
      if(x) {
        radioKey.data['value'] = x.label
      }
    }
  }

}
